export default __webpack_public_path__ + "static/media/completed.e9890fc5.png";